import { registerLicense } from '../../misc/Certificates/LicenseRegistry.js';
/**
 * License that declares the contained keys as trusted keys (the issuer knows that the keys belongs
 * to the person)
 *
 * [signature.issuer] asserts that keys in [profile] belong to the person referenced by the profile.
 */
export const TrustKeysLicense = Object.freeze({
    $type$: 'License',
    name: 'TrustKeys',
    description: '[signature.issuer] asserts that keys in [profile] belong to the person referenced by' +
        ' the profile.'
});
registerLicense(TrustKeysLicense, 'TrustKeysCertificate');
export const TrustKeysCertificateRecipe = {
    $type$: 'Recipe',
    name: 'TrustKeysCertificate',
    rule: [
        {
            itemprop: 'profile',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['Profile']) }
        },
        {
            itemprop: 'license',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['License']) }
        }
    ]
};
export const TrustKeysCertificateReverseMap = [
    'TrustKeysCertificate',
    new Set(['*'])
];
//# sourceMappingURL=TrustKeysCertificate.js.map